import React from "react";
import { CheckIcon } from "@icons";
import styles from "./TagPlayground.module.scss";

export const handleClick = () => {};
export const handleRemove = () => {};

export const leftIcon = <CheckIcon />;

export const typeHeaders8 = [
    "text",
    "text outline",
    "icon",
    "icon outline",
    "numeric",
    "numeric outline",
    "removable",
    "removable outline",
] as const;

export const typeHeaders6 = [
    "text",
    "text outline",
    "icon",
    "icon outline",
    "numeric",
    "numeric outline",
] as const;

export const typeHeaders2 = ["numeric", "numeric outline"] as const;

export const removableHeaders = ["removable", "removable outline"] as const;

export const Cell = ({ children }: { children: React.ReactNode }) => (
    <div className={styles.cell}>{children}</div>
);
